import { isAcceptableOfficeType } from 'src/constants/acceptableFileTypes'

type args = {
  trialUid: string
  trialHospitalSharedFileUid: string
  fileExtension: string
}

export const getSharedUrl = ({
  trialUid,
  trialHospitalSharedFileUid,
  fileExtension,
}: args) => {
  // MEMO: 治験共通ファイル参照で得られる拡張子のプロパティにはドットが含まれていないため、ここで付与して判定を行う
  const isDownload = isAcceptableOfficeType(`.${fileExtension}`)

  return `${
    import.meta.env.VITE_WEB_DOMAIN
  }/dashboard/trials/${trialUid}/trialHospitalSharedFiles/${trialHospitalSharedFileUid}${isDownload ? '?download=true' : ''}`
}
